module.exports = __webpack_public_path__ + "img/farzana-christopher-112.610db854.jpg";